import { render, staticRenderFns } from "./Vidburdir.vue?vue&type=template&id=47605ab7"
import script from "./Vidburdir.vue?vue&type=script&lang=js"
export * from "./Vidburdir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports